<template>
    <div class="basic_wrap">

        <img class="title" src="../images/Air-drop.png" alt="">
        <h2 class="no" v-show="current_no">No.{{ current_no }} Apertura al mundo exterior</h2>
        <button class="open-btn" @click="open()">Abrir</button>


        <div class="rules">
            <p>Reglas de lanzamiento aéreo</p>
            <p>1. Solo se puede aceptar un lanzamiento aéreo por persona por ronda.</p>
            <p>2. Una vez abierto el lanzamiento aéreo, se generará un Código. Use el Código para obtener del personal de la plataforma
            </p>
            <p>3. No abra o use lanzamiento aéreo maliciosamente</p>
            <p v-show="lastInfo.code">4. Última reclamación No.{{ lastInfo.no }} Contraseña {{ lastInfo.code }} ${{ lastInfo.money }}
                <button class="copy" @click="copyCode()">Copiar código</button>
            </p>
        </div>

    </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Toast } from "vant";
import Clipboard from "v-clipboard";
Vue.use(Clipboard);
import Axios from 'axios'

export default {
    name: "airdrop",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            can_click: false,
            lastTimeCode: null,
            lastInfo: {},
            current_no: null,
            expect: null,
            url: "https://www.phaadmin.com"
            // url: "http://gelunbiya.mm.com"
        }
    },
    created() {


        this.$parent.footer('user', false);
    },
    mounted() {


        let myQuery = this.$route.query;

        if (myQuery.e) {
            Toast.clear()

            this.init(myQuery.e);
        }
        else {
            Dialog.alert({
                title: "Lo siento",
                message: `El airdrop actual es incorrecto. Visite el enlace de airdrop correcto`,
                confirmButtonText: "OK",
                theme: 'round-button',
            });
            Toast.clear("all");
            return;
        }

    },
    methods: {
        //获取当前空投时间
        init(e) {
            console.log(123);
            let _this = this;
            Axios.get(this.url + `/api/index/getAirDrop?e=${e}`)
                .then(function (response) {

                    console.log(response);
                    if (response.data.code == 0) {
                        Dialog.alert({
                            title: "Ups",
                            message: `El airdrop actual es incorrecto. Visite el enlace de airdrop correcto`,
                            showConfirmButton: false,
                            theme: 'round-button',
                        });
                        return;
                    } else if (response.data.code == 3) {
                        //有空投、正常领取就好了
                        _this.expect = response.data.expect;
                        _this.can_click = true;
                    } else if (response.data.code == 1) {
                        _this.can_click = false;
                        //这个空投领取过了
                        Dialog.alert({
                            title: "Felicidades",
                            message: `Usted obtiene $${response.data.data.money}, tu código es ${response.data.data.code},póngase en contacto con el personal de la plataforma para obtenerlo`,
                            confirmButtonText: "Copiar código",
                            theme: 'round-button',
                            overlay: true,
                        }).then(() => {
                            _this.$copyText(response.data.data.code).then(
                                function (e) {
                                    _this.$toast({
                                        background: "#07c160",
                                        message: "Copiar con éxito",
                                    });
                                },
                                function (e) {
                                    console.log(e);
                                }
                            );
                            return false;
                        })
                    }



                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally(function () {
                    // always executed
                });

        },
        //开空投
        open() {

            if (!this.can_click) {
                this.$toast({
                    background: "#07c160",
                    message: "Has participado en esta ronda de airdrop, espera a la próxima ronda.",
                });
                return false;
            }

            Toast.loading({
                overlay: true,
                duration: 300000
            });
            let _this = this;
            Axios.get(this.url + '/api/index/openAirdrop?e=' + _this.expect)
                .then(function (response) {

                    let data = response.data;
                    console.log(data);
                    Toast.clear("all");
                    if (data.code == 1) {
                        Dialog.alert({
                            title: "Felicidades",
                            message: `Usted obtiene $${data.data.money}, tu código es ${data.data.code}, póngase en contacto con el personal de la plataforma para obtenerlo`,
                            confirmButtonText: "Copiar código",
                            theme: 'round-button',
                            //showCancelButton:true,
                            //cancelButtonText:"Copy Code",
                            overlay: true,

                        }).then(() => {
                            // on confirm
                            _this.$copyText(data.data.code).then(
                                function (e) {
                                    _this.$toast({
                                        background: "#07c160",
                                        message: "Copiar con éxito",
                                    });
                                },
                                function (e) {
                                    console.log(e);
                                }
                            );
                            _this.can_click = false;
                            return false;
                        })

                    }
                    else {
                        Dialog.alert({
                            title: "Whoops",
                            message: data.info,
                            confirmButtonText: "OK",
                            theme: 'round-button',
                        });
                        _this.can_click = false;
                    }


                })

        },

        //复制最后一轮的口令
        copyCode() {
            let _this = this;
            this.$copyText(this.lastInfo.code).then(
                function (e) {
                    _this.$toast({
                        background: "#07c160",
                        message: "Copy Successfully",
                    });
                },
                function (e) {
                    console.log(e);
                }
            );
        }

    },
}
</script>

<style lang="less" scoped>
.copy {
    background-color: rgb(135, 244, 250);
    color: rgb(74, 168, 255);
    padding: 5px;
    border-radius: 3px;
    display: block;
    margin: 0 auto;
}

.no {
    text-align: center;
    color: goldenrod;
    font-size: 0.4rem;
}

.basic_wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    background-image: url("../images/airdrop_bg.png");
    //    background-repeat:no-repeat;
    // background-attachment:fixed;
    background-position: 0px -60px;
    background-size: 100%;
}

.title {
    width: 80%;
    display: block;
    margin: 15px auto;
}

.open-btn {
    position: absolute;
    width: 50%;
    height: 50px;
    background-image: url("../images/ybtn.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: white;
    bottom: 40%;
    left: 25%;
    font-weight: 700;
    font-size: 0.45rem;
}

.rules {
    position: absolute;
    width: 85%;
    // height: 30%;
    bottom: 2%;
    left: 7.5%;
    color: goldenrod;
}

.rules b {}

.rules p {
    line-height: 22px;
    font-weight: 700;
    font-size: 0.3rem;
}
</style>
